import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import Event from "./Event";
import StepperNavigationButtons from "../StepperNavigationButtons";
import { IconPlus } from '@tabler/icons-react'

const Events = forwardRef(
  function Events(props, ref) {
    const [events, setEvents] = useState([]);

    useEffect(() => {
      if (props.data) {
        setEventData(props.data);
      }
    }, [props.data]);

    const setEventData = (data) => {
      let eventsData = [];
      data.forEach((item, index) => {
        eventsData.push({
          title: item.title,
          date: item.date,
          time: item.time,
          venue: item.venue,
          location: item.location,
          show: index == 0,
          isValid: false,
          ref: null
        })
      });

      setEvents(eventsData);
    }

    const handleAddEvent = () => {
      let event =
      {
        title: "Event " + (events.length + 1),
        date: "",
        time: "",
        venue: "",
        location: "",
        show: true,
        isValid: false,
        ref: null
      }

      setEvents(currentEvents => {
        currentEvents.forEach((event) => {
            event["show"] = false;
        });
        let newEvent  = [...currentEvents, event];
        return newEvent
      });
    }

    const showHideEvent = (index) => {
      const currentEvents = [...events];

      currentEvents.forEach((event, innerIndex) => {
        if (index == innerIndex)
          event["show"] = !event["show"];
        else
          event["show"] = false;
      });

      setEvents(currentEvents);
    }

    const deleteEventHandler = (targetIndex) => {
      const filteredEvents = events.filter((item, index) => index !== targetIndex);

      if (filteredEvents.length == 1) {
        filteredEvents[0]["show"] = true;
      }
      else{
        filteredEvents.forEach((event, index) => {
          if (index == targetIndex-1)
            event["show"] = true;
        });
      }
      setEvents(filteredEvents);
    }

    const validate = () => {
      let isValid = true;
      const currentEvents = [...events];
      currentEvents.forEach(event => {
        let validationStatus = event.ref?.validate() ?? false;
        event["isValid"] = validationStatus;

        if (!validationStatus) {
          isValid = false;
        }
      });
      setEvents(currentEvents);
      return isValid;
    }

    const getData = () => {
      let eventsData = [];

      events.forEach(event => {
        let data = event.ref?.getData() ?? null;
        if (data)
          eventsData.push(data);
      });
      return eventsData;
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));


    return (
      <div className="content d-block visible">
        <div className="content-header mb-3 d-flex justify-content-between">
          <div className="sec-titler">
            <h2 className="text-primary">Events</h2>
            <div className="title-shape"></div>
            <small className="fs-11 mb-0"></small>
          </div>
          <div className="mb-0 text-right">
            <button className="btn btn-primary align-middle" onClick={handleAddEvent}>
              <IconPlus className="me-sm-1 me-0" size={20} />
              Add Event
            </button>
          </div>
        </div>
        <form>
          <div className="row g-3">
            <div className="accordion mt-3">
            {
              (!events || (events && events.length == 0)) && (
                <div className="row justify-content-center">
                  <div className="col-md-5 col-lg-4 col-11">
                    <div className="d-flex flex-column align-items-center">
                      <img src="/images/people.svg" />
                      <div className="helper-message">
                        No events information<br /> Get started by creating
                      </div>
                      <button type="button" className="mt-2 btn btn-primary btn btn-secondary" onClick={handleAddEvent}>
                        <IconPlus className="me-sm-1 me-0" size={20} />
                        Add Event
                      </button>
                    </div>
                  </div>
                </div>
              )
              }

              {events && events.length > 0 &&
                events.map((event, index) => {
                  return (
                    <Event
                      data={event}
                      index={index}
                      showHideEvent={showHideEvent}
                      deleteEvent={deleteEventHandler}
                      key={index}
                      ref={el => event.ref = el}
                      showDelete={true} />
                  )
                })
              }
            </div>

            <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
          </div>
        </form>
      </div>
    )
  });

export default Events;
